export function LineAdresse ({ adresse })  {
  return <span className="line__adresse">
    <span className="label">{ adresse }</span>
  </span>
}

export default LineAdresse;